import cloneDeep from 'lodash/cloneDeep'
import merge from 'lodash/merge'

import {
  FridgePackageOrderStatus,
  ServiceRequestPaymentStatus,
  ServiceRequestStatus,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { BadgeColors } from '@avantstay/backoffice-core'

import { IExpiresAtProps } from '@new/domains/bookings/screens/valueAddedServices/_types'

import { BookingServiceRequest } from '@/types/servicesTypes/BookingServices.types'

interface SplitServicesRequestsSection {
  actionRequiredData: BookingServiceRequest[]
  activeData: BookingServiceRequest[]
  cancelledData: BookingServiceRequest[]
}

export const badgeColorByStockedFridgeStatus = {
  [FridgePackageOrderStatus.orderPlaced]: BadgeColors.success,
  [FridgePackageOrderStatus.inProgress]: BadgeColors.warning,
  [FridgePackageOrderStatus.orderNotPlaced]: BadgeColors.neutral,
}

export const isStatusActionRequired = (
  status: ServiceRequestStatus,
  paymentStatus: ServiceRequestPaymentStatus,
) => {
  return (
    status === ServiceRequestStatus.requested &&
    paymentStatus === ServiceRequestPaymentStatus.payLater
  )
}

export const isStatusActive = (status: ServiceRequestStatus) => {
  switch (status) {
    case ServiceRequestStatus.confirmed:
    case ServiceRequestStatus.requested:
    case ServiceRequestStatus.settled:
      return true
    default:
      return false
  }
}

export const isStatusCancelled = (status: ServiceRequestStatus) => {
  switch (status) {
    case ServiceRequestStatus.rejected:
    case ServiceRequestStatus.cancelled:
    case ServiceRequestStatus.expired:
    case ServiceRequestStatus.aborted:
      return true
    default:
      return false
  }
}

export const isServiceStatusUnpaid = (status: ServiceRequestStatus) => {
  switch (status) {
    case ServiceRequestStatus.confirmed:
    case ServiceRequestStatus.settled:
      return false
    default:
      return true
  }
}

export const isStatusUnpaid = (paymentId: string, paymentStatus: ServiceRequestPaymentStatus) =>
  !!paymentId && paymentStatus === ServiceRequestPaymentStatus.unpaid

export const splitServicesRequestsSection = (requests: BookingServiceRequest[]) => {
  const initialData: SplitServicesRequestsSection = {
    actionRequiredData: [],
    activeData: [],
    cancelledData: [],
  }

  return requests.reduce((acc, request) => {
    const { status, paymentInfo } = request

    if (isStatusActionRequired(status, paymentInfo.status)) {
      acc.actionRequiredData.push(cloneDeep(request))
    } else if (isStatusCancelled(status)) {
      acc.cancelledData.push(merge({}, request, { isDisabled: true }))
    } else if (isStatusActive(status) && paymentInfo.paymentId) {
      const isDisabled = isStatusUnpaid(paymentInfo.paymentId, paymentInfo.status)
      acc.activeData.push(merge({}, request, { isDisabled }))
    }

    return acc
  }, initialData)
}

export const shouldRenderExpiresAt = ({
  status,
  paymentStatus,
  currentAmount,
}: IExpiresAtProps) => {
  switch (status) {
    case ServiceRequestStatus.requested:
      return true
    case ServiceRequestStatus.settled:
      return paymentStatus === ServiceRequestPaymentStatus.paid
    case ServiceRequestStatus.confirmed:
      if (paymentStatus === ServiceRequestPaymentStatus.paid) {
        return currentAmount !== 0
      }
      return false

    case ServiceRequestStatus.cancelled:
    case ServiceRequestStatus.rejected:
    case ServiceRequestStatus.expired:
    case ServiceRequestStatus.aborted:
      return false
  }
}

export const EarlyCheckInID = 'd11c6738-01da-43e2-b185-f8a2b5b870da'
export const EarlyCheckInOverrideId = '685ed144-bc23-41f1-bbbf-3ebac99a1999'
export const LateCheckoutOverrideId = '1c9f5bca-f912-4746-b557-7d411fe97cdd'
